module.exports = {
    slidesToShow: 2.2,
    arrows: true,
    dots: false,
    centerPadding: '20px',
    infinite: false,
    responsive: [{
        breakpoint: 992,
        settings: {
            slidesToShow: 1.5,
        }
    }, {
        breakpoint: 768,
        settings: {
            slidesToShow: 1.2,
        }
    }, ],
    prevArrow: '<button id="prev" type="button" class="desktop_only slick-arrow slick-prev">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M14.5303 18.5303C14.2374 18.8232 13.7626 18.8232 13.4697 18.5303L7.46967 12.5303C7.17678 12.2374 7.17678 11.7626 7.46967 11.4697L13.4697 5.46967C13.7626 5.17678 14.2374 5.17678 14.5303 5.46967C14.8232 5.76256 14.8232 6.23744 14.5303 6.53033L9.06066 12L14.5303 17.4697C14.8232 17.7626 14.8232 18.2374 14.5303 18.5303Z" fill="#030D45"/>\n' +
        '</svg>' +
        '</button>',
    nextArrow: '<button id="next" type="button" class="slick-arrow slick-next desktop_only">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M14.5303 18.5303C14.2374 18.8232 13.7626 18.8232 13.4697 18.5303L7.46967 12.5303C7.17678 12.2374 7.17678 11.7626 7.46967 11.4697L13.4697 5.46967C13.7626 5.17678 14.2374 5.17678 14.5303 5.46967C14.8232 5.76256 14.8232 6.23744 14.5303 6.53033L9.06066 12L14.5303 17.4697C14.8232 17.7626 14.8232 18.2374 14.5303 18.5303Z" fill="#030D45"/>\n' +
        '</svg></button>'
    // Any other options that can be got from plugin documentation
}